import { useQuery } from "@tanstack/react-query";
import Table from "../common/Table";
import Button from "../common/Button";
import { taskService } from "../../services/tasks";
import { format } from "date-fns";
import { exportToCsv } from "../../utils/exportCsv";
import { Download } from "lucide-react";

const TaskList = ({ filters, onEdit, onDelete }) => {
  const { data: tasks, isLoading } = useQuery({
    queryKey: ["tasks", filters],
    queryFn: () => taskService.getAll(filters),
  });

  const columns = [
    { header: "Title", accessor: "title" },
    {
      header: "Due Date",
      accessor: (row) =>
        row.dueDate ? format(new Date(row.dueDate), "dd MMM") : "-",
    },
    { header: "Priority", accessor: "priority" },
    { header: "Assigned To", accessor: (row) => row.assignedTo?.name || "-" },
    { header: "Completed", accessor: (row) => (row.completed ? "Yes" : "No") },
  ];

  const actions = (row) => (
    <>
      <Button
        variant="secondary"
        className="mr-2"
        onClick={() => onEdit(row)}
      >
        Edit
      </Button>
      <Button
        variant="danger"
        onClick={() => onDelete(row._id)}
      >
        Delete
      </Button>
    </>
  );

  if (isLoading) return <div>Loading...</div>;

  return (
    <div>
      <div className="flex justify-end mb-3">
        <button
          onClick={() => exportToCsv("tasks", tasks, columns)}
          className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-gray-600 hover:text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          <Download className="w-4 h-4" />
          Export CSV
        </button>
      </div>
      <Table columns={columns} data={tasks} actions={actions} />
    </div>
  );
};

export default TaskList;
